import React, { Component } from "react";
import Link from "gatsby-link";
import { Container, Grid, Responsive, Dropdown } from "semantic-ui-react";
import Button from "../transparentButton";
import CalcButton from "../calcButton";
import headImg from "../../assets/headimg.jpg";
import Slider from "../slider";
import { connect } from "react-redux";
import {
  updateBathrooms,
  updateBedrooms,
  updateFrequency
} from "../../actions/CleaningActions";
import stylesModule from "./header.module.css";
const styles = {
  paddingTop: { paddingTop: "3rem" },
  someSpace: {
    // width: "90%",
    margin: "0 auto"
  },
  minimumButtonText: {
    minHeight: "80px"
  }
};
const bathroomOptions = [
  { key: 1, text: "One Bathroom", value: 1 },
  { key: 2, text: "Two Bathrooms", value: 2 },
  { key: 3, text: "Three Bathrooms", value: 3 },
  { key: 4, text: "Four Bathrooms", value: 4 },
  { key: 5, text: "Five Bathrooms", value: 5 },
  { key: 6, text: "Six Bathrooms", value: 6 }
];
const bedroomOptions = [
  { key: 1, text: "One Bedroom", value: 1 },
  { key: 2, text: "Two Bedrooms", value: 2 },
  { key: 3, text: "Three Bedrooms", value: 3 },
  { key: 4, text: "Four Bedrooms", value: 4 },
  { key: 5, text: "Five Bedrooms", value: 5 },
  { key: 6, text: "Six Bedrooms", value: 6 }
];

class IndexHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      numRooms: 1,
      numBathRooms: 1,
      selectedService: "twoWeeks"
    };
  }
  updateRoomValue = value => {
    this.props.updateBedrooms(value);
  };
  updatebRoomValue = value => {
    this.props.updateBathrooms(value);
  };
  updateSelectedService = service => {
    this.props.updateFrequency(service);
  };
  render() {
    return (
      <div>
        {this.props.children}
        <div
          style={{
            minHeight: "100vh",
            textAlign: "center",
            paddingTop: "12vh",
            color: "white"
          }}
        >
          <Container text style={{ paddingBottom: "50px" }}>
            <h2>Jacksonville's Most Affordable Cleaning Service.</h2>
            {/*<img src={headImg} alt="" />*/}
            <h3>Book a trusted maid instantly below.</h3>
            <Grid stackable style={styles.paddingTop} centered>
              <Grid.Row verticalAlign="middle">
                <Grid.Column>
                  <Dropdown
                    fluid
                    onChange={(e, { value }) => this.updateRoomValue(value)}
                    options={bedroomOptions}
                    placeholder="Choose an option"
                    selection
                    value={this.props.bedrooms}
                  />
                </Grid.Column>
              </Grid.Row>
              {/* <Responsive as={Grid.Row} minWidth={500} verticalAlign="middle">
                <Grid.Column width={4}>
                  <div style={{ width: "90%", margin: "0 auto" }}>
                    Bedrooms: {this.props.bedrooms}
                  </div>
                </Grid.Column>
                <Grid.Column width={10}>
                  <div style={styles.someSpace}>
                    <Slider handleUpdateValue={this.updateRoomValue} />
                  </div>
                </Grid.Column>
              </Responsive> */}
              <Grid.Row verticalAlign="middle">
                <Grid.Column>
                  <Dropdown
                    className={stylesModule.marginBottomImportant}
                    fluid
                    onChange={(e, { value }) => this.updatebRoomValue(value)}
                    options={bathroomOptions}
                    placeholder="Choose an option"
                    selection
                    value={this.props.bathrooms}
                  />
                </Grid.Column>
              </Grid.Row>
              {/* <Responsive as={Grid.Row} minWidth={500} verticalAlign="middle">
                <Grid.Column width={4}>
                  <div style={styles.someSpace}>
                    Bathrooms: {this.props.bathrooms}
                  </div>
                </Grid.Column>

                <Grid.Column width={10}>
                  <div style={styles.someSpace}>
                    <Slider handleUpdateValue={this.updatebRoomValue} />
                  </div>
                </Grid.Column>
              </Responsive> */}
              <Grid.Row columns="4" verticalAlign="top">
                <Grid.Column textAlign="center">
                  <div style={{ ...styles.minimumButtonText }}>
                    <Button
                      handleItemClick={() =>
                        this.updateSelectedService("oneTime")}
                      active={this.props.frequency === "oneTime"}
                    >
                      One Time Service
                    </Button>
                  </div>
                </Grid.Column>
                <Grid.Column textAlign="center">
                  <div>
                    <Button
                      handleItemClick={() =>
                        this.updateSelectedService("everyWeek")}
                      active={this.props.frequency === "everyWeek"}
                    >
                      Every week
                    </Button>

                    <span>20% Off</span>
                  </div>
                </Grid.Column>
                <Grid.Column textAlign="center">
                  <div>
                    <Button
                      handleItemClick={() =>
                        this.updateSelectedService("twoWeeks")}
                      active={this.props.frequency === "twoWeeks"}
                    >
                      Every two weeks (Most popular)
                    </Button>
                    <span>15% Off</span>
                  </div>
                </Grid.Column>
                <Grid.Column textAlign="center">
                  <div>
                    <Button
                      handleItemClick={() =>
                        this.updateSelectedService("fourWeeks")}
                      active={this.props.frequency === "fourWeeks"}
                    >
                      Every 4 weeks
                    </Button>
                    <span>10% Off</span>
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <div>
                  <Link to={"/booking"}>
                    <CalcButton price={this.props.price} />
                  </Link>
                </div>
              </Grid.Row>
            </Grid>
          </Container>
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateBathrooms: num => {
      dispatch(updateBathrooms(num));
    },
    updateBedrooms: num => {
      dispatch(updateBedrooms(num));
    },
    updateFrequency: freq => {
      dispatch(updateFrequency(freq));
    }
  };
};
const mapStateToProps = (state, ownProps) => {
  return {
    bathrooms: state.cleaning.bathrooms,
    bedrooms: state.cleaning.bedrooms,
    frequency: state.cleaning.frequency,
    price: state.cleaning.price
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IndexHeader);



// WEBPACK FOOTER //
// ./src/components/IndexHeader/header.jsx